export * from './addAwsWafScript.web';
